var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppDialog',{attrs:{"dialogName":'InstallExtDialog'},on:{"onCancel":function($event){return _vm.dialogPromiseHandlers.reject()}}},[_c('InstallPlyExtensionLoader',{staticClass:"dialog-content",attrs:{"minimalVersion":_vm.minimalVersion},on:{"extension-installed":_vm.extensionInstalled}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }